module.exports = import("https://esm.sh/@ffmpeg/util@0.12.1");;